{
  "error": {
    "server_connection_failed": "Ошибка подключения к серверу.  "
  },
  "term": {
    "affects_all_instances": "Affects all {count} instances",
    "affects_this_instance_only": "Affects only this instance",
    "application": "Приложение",
    "attributes": "Атрибуты",
    "bytes": "Байты",
    "cancel": "Отменить",
    "clear": "Очистить",
    "cleared": "Очищено",
    "close": "Закрыть",
    "confirm": "Подтвердить",
    "delete": "Удалить",
    "deleted": "Удален",
    "duration": "Задержка",
    "event": "Событие",
    "ever": "всегда",
    "executing": "Выполнение...",
    "execution_failed": "Ошибка при выполнении.",
    "execution_successful": "Успешно выполнено.",
    "failed": "Ошибка",
    "float": "Float",
    "hours": "{count} ч. | {count} ч.",
    "instances": "Экземпляры",
    "integer": "Integer",
    "milliseconds": "Мс.",
    "minutes": "{count} мин. | {count} мин.",
    "percent": "процент",
    "name": "Имя",
    "operations": "Операции",
    "save": "Сохранить",
    "stacktrace": "Stacktrace",
    "suppress": "Скрыть",
    "time": "Время",
    "unsuppress": "Включить",
    "username": "Имя пользователя"
  },
  "time_short": {
    "unknown": "неизвестно",
    "milliseconds": "{count}мс",
    "seconds": "{count}с",
    "minutes": "{count}мин",
    "hours": "{count}ч",
    "days": "{count}д",
    "weeks": "{count}нед",
    "months": "{count}мес",
    "years": "{count}г"
  }
}
